import { UsuarioCadastrosRequest } from 'api/Assessor/usuario';

interface CadastrosState {
  filters: Partial<UsuarioCadastrosRequest> | undefined;
  hasDateError: boolean;
}

interface ActionSetFilters {
  name: 'setFilters';
  payload: Partial<UsuarioCadastrosRequest> | undefined;
}

interface ActionSetPage {
  name: 'setPage';
  payload: number;
}

interface ActionSetCount {
  name: 'setCount';
  payload: number;
}

interface ActionFlagRelatorio {
  name: 'setGerandoRelatorio';
  payload: boolean;
}

interface ActionFlagDataError {
  name: 'setDateErrorFlag';
  payload: boolean;
}

type CadastroActions =
  | ActionSetFilters
  | ActionSetPage
  | ActionSetCount
  | ActionFlagRelatorio
  | ActionFlagDataError;

export const cadastroInitialState: CadastrosState = {
  filters: undefined,
  hasDateError: false,
};

export const cadastroReducer = (
  state: CadastrosState,
  action: CadastroActions
): CadastrosState => {
  switch (action.name) {
    case 'setFilters':
      return { ...state, filters: action.payload };
    case 'setDateErrorFlag':
      return { ...state, hasDateError: action.payload };
    default:
      return state;
  }
};
